module.exports = new __parcel__URL__("preview.70324aad.mp4").toString();